// client/src/constants/productConstants.js

export const PRODUCT_LIST_REQUEST = "PRODUCT_LIST_REQUEST";
export const PRODUCT_LIST_SUCCESS = "PRODUCT_LIST_SUCCESS";
export const PRODUCT_LIST_FAIL = "PRODUCT_LIST_FAIL";
export const PRODUCT_LIST_RESET = "PRODUCT_LIST_RESET";

export const PRODUCT_LATEST_REQUEST = "PRODUCT_LATEST_REQUEST";
export const PRODUCT_LATEST_SUCCESS = "PRODUCT_LATEST_SUCCESS";
export const PRODUCT_LATEST_FAIL = "PRODUCT_LATEST_FAIL";
export const PRODUCT_LATEST_RESET = "PRODUCT_LATEST_RESET";

export const PRODUCT_FEATURED_REQUEST = "PRODUCT_FEATURED_REQUEST";
export const PRODUCT_FEATURED_SUCCESS = "PRODUCT_FEATURED_SUCCESS";
export const PRODUCT_FEATURED_FAIL = "PRODUCT_FEATURED_FAIL";
export const PRODUCT_FEATURED_RESET = "PRODUCT_FEATURED_RESET";

export const PRODUCT_DETAILS_REQUEST = "PRODUCT_DETAILS_REQUEST";
export const PRODUCT_DETAILS_SUCCESS = "PRODUCT_DETAILS_SUCCESS";
export const PRODUCT_DETAILS_FAIL = "PRODUCT_DETAILS_FAIL";
export const PRODUCT_DETAILS_RESET = "PRODUCT_DETAILS_RESET";

export const PRODUCT_BY_SLUG_REQUEST = "PRODUCT_BY_SLUG_REQUEST";
export const PRODUCT_BY_SLUG_SUCCESS = "PRODUCT_BY_SLUG_SUCCESS";
export const PRODUCT_BY_SLUG_FAIL = "PRODUCT_BY_SLUG_FAIL";
export const PRODUCT_BY_SLUG_RESET = "PRODUCT_BY_SLUG_RESET";

export const PRODUCT_RESOLVE_REQUEST = "PRODUCT_RESOLVE_REQUEST";
export const PRODUCT_RESOLVE_SUCCESS = "PRODUCT_RESOLVE_SUCCESS";
export const PRODUCT_RESOLVE_FAIL = "PRODUCT_RESOLVE_FAIL";
export const PRODUCT_RESOLVE_RESET = "PRODUCT_RESOLVE_RESET";

/* -------------------------------------------------------------------------- */
/*                         Product recommendations                            */
/* -------------------------------------------------------------------------- */

export const PRODUCT_RECOMMENDATIONS_REQUEST =
  "PRODUCT_RECOMMENDATIONS_REQUEST";

export const PRODUCT_RECOMMENDATIONS_SUCCESS =
  "PRODUCT_RECOMMENDATIONS_SUCCESS";

export const PRODUCT_RECOMMENDATIONS_FAIL =
  "PRODUCT_RECOMMENDATIONS_FAIL";

export const PRODUCT_RECOMMENDATIONS_RESET =
  "PRODUCT_RECOMMENDATIONS_RESET";
